export const SGCM_SITE_DOMAIN = process.env.NEXT_PUBLIC_SGCM_SITE_DOMAIN;
export const SGCM_MEDIA_ORIGIN = process.env.NEXT_PUBLIC_SGCM_MEDIA_ORIGIN;
export const SGCM_SITE_ORIGIN = process.env.NEXT_PUBLIC_SGCM_SITE_ORIGIN;
export const SGCM_MOBILE_SITE_ORIGIN = process.env.NEXT_PUBLIC_SGCM_MOBILE_SITE_ORIGIN; // @suppress longLineCheck
export const SGCM_MS_SITE_ORIGIN = process.env.NEXT_PUBLIC_SGCM_MS_SITE_ORIGIN;
export const SGCM_MYCARFORUM_ORIGIN = process.env.NEXT_PUBLIC_SGCM_MYCARFORUM_ORIGIN; // @suppress longLineCheck
